// client/src/components/common/AdminRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Loader } from 'lucide-react';

const AdminRoute = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <Loader className="animate-spin text-eduvibe-green" size={48} />
      </div>
    );
  }

  // Check if user is logged in AND is an admin
  if (!user || !user.isAdmin) {
    console.warn('AdminRoute: User is not authorized. Redirecting.', { user });
    return <Navigate to="/dashboard" replace />;
  }

  console.log('[AdminRoute DEBUG] User is authorized, rendering Outlet.', { user });
  return <Outlet />;
};

export default AdminRoute;
